import script from "./appDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./appDetails.vue?vue&type=script&setup=true&lang=js"

import "./appDetails.vue?vue&type=style&index=0&id=36b3e1bb&lang=scss&scoped=true"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b3e1bb"]])

export default __exports__